import { render, staticRenderFns } from "./Box6.vue?vue&type=template&id=a5806ab0&scoped=true&"
import script from "./Box6.vue?vue&type=script&lang=js&"
export * from "./Box6.vue?vue&type=script&lang=js&"
import style0 from "./Box6.vue?vue&type=style&index=0&id=a5806ab0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5806ab0",
  null
  
)

export default component.exports